import i18n, { BackendModule, ReadCallback, ResourceLanguage } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { en } from './en';

export const defaultNS = 'common';

// Only English ships with the app; the other languages were half of the console entry
// chunk, so each is its own chunk and fetched when a browser asks for it.
const languageLoaders: Record<string, () => Promise<ResourceLanguage>> = {
  'de-DE': () => import('./de').then((module) => module.de),
  'es-ES': () => import('./es').then((module) => module.es),
  'pt-BR': () => import('./pt-br').then((module) => module.pt),
  'it-IT': () => import('./it').then((module) => module.it),
  'fr-FR': () => import('./fr').then((module) => module.fr),
  'ja-JP': () => import('./ja').then((module) => module.ja),
  'ko-KR': () => import('./ko').then((module) => module.ko),
  'nl-NL': () => import('./nl').then((module) => module.nl),
  'fi-FI': () => import('./fi').then((module) => module.fi),
  'hu-HU': () => import('./hu').then((module) => module.hu),
  'pl-PL': () => import('./pl').then((module) => module.pl),
  'sk-SK': () => import('./sk').then((module) => module.sk),
  'sv-SE': () => import('./sv').then((module) => module.sv),
};

export const resources = {
  'en-US': en,
};

const supportedLngs = ['en-US', ...Object.keys(languageLoaders)];

const lazyLanguageBackend: BackendModule = {
  type: 'backend',
  init: () => {},
  read: (language: string, namespace: string, callback: ReadCallback) => {
    const load = languageLoaders[language];
    if (!load) {
      callback(null, {});
      return;
    }
    load().then(
      (bundle) => callback(null, bundle[namespace] ?? {}),
      (error: Error) => callback(error, undefined),
    );
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(lazyLanguageBackend)
  .init({
    resources,
    // Without the namespace list i18next only asks the backend for the default
    // 'translation' namespace, finds nothing and settles on English.
    ns: Object.keys(en),
    partialBundledLanguages: true,
    fallbackLng: {
      default: ['en-US'],
    },
    supportedLngs,
    interpolation: {
      escapeValue: false,
    },
    defaultNS,
  });
